import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MoreContentButton from '../atoms/MoreContentButton';

const styles = {
  overWrap: {
    whiteSpace: 'pre-line',
    width: '500px'
  }
};

const enhance = compose(pure);

const MenuTableBody = enhance(
  ({
    menus,
    classes,
    emptyRows,
    page,
    rowsPerPage,
    setMenuIdChange,
    setMenuName,
    messageViewAction,
    setIncludedTaxPrice
  }) => {
    return (
      <TableBody>
        {menus &&
          menus
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(result => {
              const moreMessageLength = Number(
                process.env.REACT_APP_MORE_MESSAGE_LENGTH
              );
              return (
                <TableRow key={result.menuId}>
                  <TableCell>
                    <input
                      type="radio"
                      name="radioMenu"
                      onChange={() => {
                        setMenuIdChange(result.menuId);
                        setMenuName(result.menuName);
                        setIncludedTaxPrice(result.includedTaxPrice);
                      }}
                    />
                  </TableCell>
                  <TableCell>{result.menuId}</TableCell>
                  <TableCell>{result.shopId}</TableCell>
                  <TableCell>{result.groupId}</TableCell>
                  <TableCell>{result.menuName}</TableCell>
                  <TableCell>
                    {result.description && (
                      <div className={classes.overWrap}>
                        {result.description &&
                          result.description.length > moreMessageLength &&
                          result.description.substring(0, moreMessageLength)}
                        {result.description &&
                          result.description.length > moreMessageLength && (
                            <MoreContentButton
                              content={result.description}
                              onClickAction={messageViewAction}
                            />
                          )}
                        {result.description &&
                          result.description.length <= moreMessageLength &&
                          result.description}
                      </div>
                    )}
                  </TableCell>
                  <TableCell>{result.price}</TableCell>
                  <TableCell>{result.taxAmount}</TableCell>
                  <TableCell>{result.includedTaxPrice}</TableCell>
                  <TableCell>{result.excludedTaxPrice}</TableCell>
                  <TableCell>{result.taxType}</TableCell>
                  <TableCell>{result.reducedTaxType}</TableCell>
                </TableRow>
              );
            })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={13} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(MenuTableBody);
